import React, { memo } from 'react'
import { MenuItem, Select } from '@mui/material'
import styled from '@emotion/styled'
import Box from './Box'
import useAppState from '../hooks/useAppState'
import swedishFlag from '/swedishFlag.svg'
import britishFlag from '/britishFlag.svg'
import norwegianFlag from '/norwegianFlag.svg'

const PrivateLessonsLanguageToggle: React.FC = () => {
  const { state, setState } = useAppState()

  return (
    <Container direction="row" align="center">
      <StyledSelect
        size="small"
        value={state.selectedLanguage}
        onChange={(e) => setState({ ...state, selectedLanguage: e.target.value as any })}
        renderValue={(value) => {
          const flagSrc = value === 'sv' ? swedishFlag : value === 'no' ? norwegianFlag : britishFlag
          const label = value === 'sv' ? 'SE' : value === 'no' ? 'NO' : 'EN'
          return (
            <ValueRow direction="row" align="center" gap="8px">
              <img src={flagSrc} width={20} height={20} alt={`${label} flag`} />
              <ValueText>{label}</ValueText>
            </ValueRow>
          )
        }}
        MenuProps={{
          PaperProps: {
            sx: { borderRadius: 2 }
          }
        }}
      >
        <MenuItem value="sv">
          <MenuRow direction="row" align="center" gap="8px">
            <img src={swedishFlag} width={20} height={20} alt="Swedish flag" />
            <MenuText>SE</MenuText>
          </MenuRow>
        </MenuItem>
        <MenuItem value="en">
          <MenuRow direction="row" align="center" gap="8px">
            <img src={britishFlag} width={20} height={20} alt="British flag" />
            <MenuText>EN</MenuText>
          </MenuRow>
        </MenuItem>
        <MenuItem value="no">
          <MenuRow direction="row" align="center" gap="8px">
            <img src={norwegianFlag} width={20} height={20} alt="Norwegian flag" />
            <MenuText>NO</MenuText>
          </MenuRow>
        </MenuItem>
      </StyledSelect>
    </Container>
  )
}

const Container = styled(Box)`
  user-select: none;
`

const StyledSelect = styled(Select)`
  min-width: 92px;
  background: white;
  color: #000;
  border-radius: 10px;

  .MuiSelect-select {
    padding: 8px 12px;
  }
`

const ValueRow = styled(Box)``

const ValueText = styled.span`
  color: #000;
  font-size: 13px;
  font-weight: 600;
`

const MenuRow = styled(Box)``

const MenuText = styled.span`
  color: #000;
  font-size: 13px;
  font-weight: 600;
`

export default memo(PrivateLessonsLanguageToggle)
